module.exports = __webpack_public_path__ + "static/media/Banana2.b5db877c.png";